import { createSlice } from '@reduxjs/toolkit';
import { getImageUrlsApi } from '../../../rtk-apis/express/getImageUrls';

export interface GetImageUrlsState {
  status: string;
  result: any;
  msg: string;
  loading: boolean;
}

const initialState: GetImageUrlsState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
};

const getImageUrlsSlice = createSlice({
  name: 'getImageUrls',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getImageUrlsApi.pending, state => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(getImageUrlsApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'fulfilled';
        state.result = action.payload;
        state.msg = 'Image URLs fetched successfully';
      })
      .addCase(getImageUrlsApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'rejected';
        state.result = action.payload;
        state.msg = 'Failed to fetch image URLs';
      });
  },
});

export const { clearState } = getImageUrlsSlice.actions;
export default getImageUrlsSlice.reducer;
